module.exports = __webpack_public_path__ + "img/sneak-into-basket.4c1ef42b.png";